import {
    CREATE_PROCESS_REQUEST,
    CREATE_PROCESS_SUCCESS,
    CREATE_PROCESS_FAILURE,
    DELETE_PROCESS_REQUEST,
    DELETE_PROCESS_SUCCESS,
    DELETE_PROCESS_FAILURE,
    FETCH_SINGLE_PROCESS_REQUEST,
    FETCH_SINGLE_PROCESS_SUCCESS,
    FETCH_SINGLE_PROCESS_FAILURE,
    FETCH_PROCESS_REQUEST,
    FETCH_PROCESS_SUCCESS,
    FETCH_PROCESS_FAILURE,
    UPDATE_PROCESS_REQUEST,
    UPDATE_PROCESS_SUCCESS,
    UPDATE_PROCESS_FAILURE,
    RESET_PROCESS_INFO,
    CREATE_PROCESS_FORM,
    UPDATE_PROCESS_FORM,
    NAVIGATE_PROCESS,
    NAVIGATE_PROCESS_DETAILS,
    CREATE_ASSIGN_PROCESS_SUCCESS,
    CREATE_ASSIGN_PROCESS_FAILURE,
    CREATE_ASSIGN_PROCESS_REQUEST,
    FETCH_ASSIGN_PROCESS_SUCCESS,
    FETCH_ASSIGN_PROCESS_FAILURE,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST,
    FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST,
    FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE,
    UPDATE_ASSIGN_PROCESS_SUCCESS,
    FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS,
    DELETE_ASSIGN_PROCESS_SUCCESS,
    RESET_ASSIGN_PROCESS_INFO,
    CREATE_ASSIGN_PROCESS_FORM,
    UPDATE_ASSIGN_PROCESS_FORM,
    DELETE_ASSIGN_PROCESS_FAILURE,
    FETCH_SINGLE_ASSIGN_PROCESS_FAILURE,
    UPDATE_ASSIGN_PROCESS_FAILURE,
    FETCH_ASSIGN_PROCESS_REQUEST,
    DELETE_ASSIGN_PROCESS_REQUEST,
    UPDATE_ASSIGN_PROCESS_REQUEST,
    FETCH_SINGLE_ASSIGN_PROCESS_REQUEST,
    FETCH_PROGRAM_MAPPING_REQUEST,
    FETCH_PROGRAM_MAPPING_SUCCESS,
    FETCH_PROGRAM_MAPPING_FAILURE
} from './process.actionType';

export const PROCESS = 'processMaster';

let initialState = {
    loading: false,
    processList: [],
    assignProcessList: [],
    assignProcessListById: [],
    assignProgramListById: [],
    programMappingByProcessIdList: [],
    processform: {},
    processAssignForm: {},
    selectedState: {},
    errorMessage: '',
    singleProcess: {},
    isProcessFlow: false,
    assignProcessStatus: ''
};

export let processReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_PROCESS_REQUEST:
        case CREATE_ASSIGN_PROCESS_REQUEST:
        case FETCH_ASSIGN_PROCESS_REQUEST:
        case UPDATE_PROCESS_REQUEST:
        case UPDATE_ASSIGN_PROCESS_REQUEST:
        case FETCH_SINGLE_PROCESS_REQUEST:
        case FETCH_SINGLE_ASSIGN_PROCESS_REQUEST:
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_REQUEST:
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_REQUEST:
        case DELETE_PROCESS_REQUEST:
        case DELETE_ASSIGN_PROCESS_REQUEST:
        case FETCH_PROGRAM_MAPPING_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processList: updatePayload
            };
        case FETCH_PROGRAM_MAPPING_SUCCESS:
            return {
                ...state,
                loading: false,
                assignProgramListById: updatePayload
            };
        case FETCH_ASSIGN_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                assignProcessList: updatePayload
            };
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                assignProcessListById: updatePayload
            };
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                programMappingByProcessIdList: updatePayload
            };
        case CREATE_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processform: {},
                processId: updatePayload
            };
        case CREATE_ASSIGN_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignForm: {},
                assignProcessStatus: updatePayload
            };
        case UPDATE_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processform: {}
            };
        case UPDATE_ASSIGN_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignForm: {}
            };
        case FETCH_SINGLE_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processform: updatePayload
            };
        case FETCH_SINGLE_ASSIGN_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignForm: updatePayload
            };
        case DELETE_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processform: {}
            };
        case DELETE_ASSIGN_PROCESS_SUCCESS:
            return {
                ...state,
                loading: false,
                processAssignForm: {}
            };
        case RESET_PROCESS_INFO:
            return {
                ...state,
                processform: {}
            };
        case RESET_ASSIGN_PROCESS_INFO:
            return {
                ...state,
                processAssignForm: {}
            };
        case CREATE_PROCESS_FORM:
        case UPDATE_PROCESS_FORM:
            return {
                ...state,
                loading: false,
                processform: {
                    ...state.processform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_ASSIGN_PROCESS_FORM:
        case UPDATE_ASSIGN_PROCESS_FORM:
            return {
                ...state,
                loading: false,
                processAssignForm: {
                    ...state.processAssignForm,
                    [payload.key]: payload.value
                }
            };
        case CREATE_PROCESS_FAILURE:
            return {
                ...state,
                loading: false,
                assignProcessStatus: '404'
            };
        case CREATE_PROCESS_REQUEST:
            return {
                ...state,
                loading: false,
                assignProcessStatus: ''
            };
        case FETCH_PROCESS_FAILURE:
        case FETCH_ASSIGN_PROCESS_FAILURE:
        case UPDATE_ASSIGN_PROCESS_FAILURE:
        case CREATE_ASSIGN_PROCESS_FAILURE:
        case FETCH_SINGLE_PROCESS_FAILURE:
        case FETCH_SINGLE_ASSIGN_PROCESS_FAILURE:
        case FETCH_ASSIGN_PROCESS_STYLE_BY_ID_FAILURE:
        case FETCH_PROGRAM_MAPPING_BY_PROCESS_ID_FAILURE:
        case DELETE_PROCESS_FAILURE:
        case DELETE_ASSIGN_PROCESS_FAILURE:
        case FETCH_PROGRAM_MAPPING_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_PROCESS_DETAILS:
            return {
                ...state,
                isProcessFlow: true,
                singleProcess: updatePayload.singleProcess
            };
        case NAVIGATE_PROCESS:
            return {
                ...state,
                isProcessFlow: false
            };
        default:
            return state;
    }
};
